import { compose } from "redux";
import React, { PureComponent } from "react";
import { Grid, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { HeaderBase, LogoAndAppTitle } from "altus-ui-components";

import routePaths from "app/routePaths";
import UserDropdown from "app/components/UserDropdown";
import { APP_NAME } from "app/app.constants";

class SettingsHeader extends PureComponent {
  render() {
    const { classes } = this.props;

    return (
      <HeaderBase>
        <Grid container alignItems="center">
          <Grid container item xs alignItems="center" spacing={3}>
            <LogoAndAppTitle title={APP_NAME} to={routePaths.root} />
          </Grid>
          <Grid item>
            <Typography
              variant="subtitle1"
              color="secondary"
              className={classes.header}
            >
              Settings
            </Typography>
          </Grid>
          <Grid item container xs justifyContent="flex-end">
            <Grid item>
              <UserDropdown />
            </Grid>
          </Grid>
        </Grid>
      </HeaderBase>
    );
  }
}

const styles = theme => ({
  header: {
    fontWeight: theme.typography.fontWeightMedium,
  },
});

export default compose(withStyles(styles))(SettingsHeader);
